document.addEventListener('turbo:load', () => {
    const searchField = document.querySelector('#search-field');
    if (searchField) {
        const fieldValueLength = searchField.value.length;
        searchField.focus();
        searchField.setSelectionRange(fieldValueLength, fieldValueLength);
    }
});
